module.exports = __webpack_public_path__ + "img/box-hash-btn1.f28f6a5e.png";